import React from "react";

const money = (v) => Number(v || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// "VAT 16%" when every line with an amount carries the same rate, plain
// "VAT" when rates are mixed (e.g. a 0% exempt item alongside 16% ones).
export const vatRateLabel = (lines, pick = (l) => l.vatPercent) => {
  const rates = [...new Set(lines.map((l) => (pick(l) == null || pick(l) === "" ? null : Number(pick(l)))).filter((r) => r != null))];
  return rates.length === 1 ? rates[0] : null;
};

/**
 * Stock-In / Stock-Out totals (2026-09-14): Sub Total (ex VAT) + VAT = Grand
 * Total, each figure the sum of the per-line rounded amounts - the same
 * numbers the API stores (Batch172) and the print shows.
 */
const StockVatTotals = ({ subTotal, vatAmount, grandTotal, vatRate }) => (
  <table className="table table-sm table-bordered mb-0" style={{ minWidth: 260 }}>
    <tbody>
      <tr>
        <td>Sub Total (ex VAT)</td>
        <td className="text-end">{money(subTotal)}</td>
      </tr>
      <tr>
        <td>VAT{vatRate != null ? ` ${vatRate}%` : ""}</td>
        <td className="text-end">{money(vatAmount)}</td>
      </tr>
      <tr className="fw-bold">
        <td>Grand Total (inc VAT)</td>
        <td className="text-end">{money(grandTotal)}</td>
      </tr>
    </tbody>
  </table>
);

export default StockVatTotals;
